/**
 * ECharts Option Builder — Pie / Donut chart.
 */
import type { EChartsOption } from 'echarts';
import { type ChartTheme, buildBaseOption, tooltipConfig, legendConfig } from '../theme';
import type { ChartData } from '../../../../api/types';
import { colIdx } from './utils';

export function buildPieChart(
  data: ChartData,
  theme: ChartTheme,
  animated: boolean,
): EChartsOption {
  const meta = data.meta;
  const nameIdx = colIdx(data, meta?.x ?? data.columns[0].name);
  const valueIdx = colIdx(data, meta?.y?.[0] ?? data.columns[1]?.name ?? data.columns[0].name);

  const pieData = data.rows.map((row) => ({
    name: String(row[nameIdx] ?? ''),
    value: row[valueIdx] ?? 0,
  }));

  return {
    ...buildBaseOption(theme, animated),
    grid: undefined, // pie doesn't use cartesian grid
    xAxis: undefined,
    yAxis: undefined,
    tooltip: tooltipConfig(theme, 'item'),
    legend: { ...legendConfig(theme), top: 0, itemGap: 20 },
    series: [
      {
        type: 'pie',
        radius: ['45%', '70%'],
        center: ['50%', '55%'],
        data: pieData,
        label: { show: true, formatter: '{b}' },
        labelLine: { show: true },
        emphasis: { focus: 'none' as const, scale: false },
      },
    ],
  };
}